import { BACKEND_URL_V1, post } from "lib/Api";
import { FMSError } from "types/Error";
import { IUpdateGrn, IUpdateGrnResponse } from "types/PurchaseOrder";

export const updateGrn = async (
  purchaseOrderId: string,
  updateGrnRequest: IUpdateGrn
): Promise<IUpdateGrnResponse | FMSError> => {
  try {
    const response = await post<IUpdateGrnResponse>(
      `${BACKEND_URL_V1}/purchaseOrders/${purchaseOrderId}/grn`,
      updateGrnRequest
    );

    if (Math.floor(response.status / 100) === 2) {
      return response.parsedBody ?? { updatedStocks: [] };
    }
    const errorMessage =
      response.serverError?.error.message ?? "GRN could not be updated";
    return new FMSError(errorMessage);
  } catch (err) {
    // Change error state after http change
    return new FMSError("Something went wrong");
  }
};
